import { isEmpty as isHtmlEmpty } from '@paintscout/util/util'
import type { PresentationIsEmptyProps } from '../../'

/**
 * Terms have nothing to show, so the block is dropped on every read-only surface.
 *
 * `content` is HTML, and "blank" terms are rarely the empty string — the editor leaves behind
 * `<p></p><p></p>`, `<p><br></p>` or `&nbsp;`. The old check was a single
 * `.replace('<p></p>', '')`, which only removed the *first* empty paragraph, so two of them read as
 * content and the customer view drew an empty bordered box below the estimate (ENG-1494). Strip the
 * tags instead, the same test `DocumentsIsEmpty` and `PresentationAcceptButton` already use.
 *
 * An accepted quote with a customer signature keeps the section even with no terms text — the
 * signature card renders inside `QuoteTerms`, so dropping the block would hide it (this mirrors the
 * v1 `presentation/sections/Terms/TermsIsEmpty`).
 */
export default function isEmpty({ quote }: PresentationIsEmptyProps) {
  const hasContent = !!quote?.terms?.content && !isHtmlEmpty(quote.terms.content)
  const isAccepted = quote?.status?.value === 'accepted'
  const hasSignature = !!quote?.signatures?.customer

  return !hasContent && !(isAccepted && hasSignature)
}
